"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ValueChecker = /** @class */ (function () {
    function ValueChecker() {
    }
    ValueChecker.isBlank = function (value) {
        if (value === undefined ||
            value === null ||
            value === '') {
            return true;
        }
        var stringValue = String(value);
        return stringValue.trim() === '';
    };
    ValueChecker.isPresent = function (value) {
        return !ValueChecker.isBlank(value);
    };
    return ValueChecker;
}());
exports.default = ValueChecker;



//////////////////
// WEBPACK FOOTER
// ./common/src/utils/value_checker.ts
// module id = hg6G
// module chunks = 1